// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"825386d9","455":"6575cce3","977":"01378288"}[chunkId] + ".chunk.js";
};